/**
 * Auth sentinels for PropWise
 *
 * AuthContext.login() throws these as Error messages and Login.tsx recognises
 * them. They live here, not in AuthContext.tsx, because App.test.tsx mocks the
 * AuthContext module wholesale and a constant exported from it would be
 * undefined under that test.
 */

/** Thrown by login() when an admin-created user must set a new password. */
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';

/** Thrown by login() when the account exists but its email is not yet confirmed. */
export const CONFIRM_SIGN_UP_REQUIRED = 'CONFIRM_SIGN_UP_REQUIRED';

/**
 * Thrown by login() when Cognito requires a password reset before sign-in,
 * as it does after support runs admin-reset-user-password. That command has
 * already emailed a code, so Login goes straight to the reset-code step.
 */
export const PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED';

/**
 * Thrown by registerAccount() when the Pre Sign-up bot check refused the
 * signup (or, rarely, the trigger timed out), so it stays neutral. Cognito's
 * own message ("PreSignUp failed with error ...") is never shown.
 */
export const BOT_CHECK_FAILED_MESSAGE =
  "We couldn't complete the security check. Please try it again and resubmit.";

/** Shown on the signup form when the Turnstile widget fails to load or errors. */
export const BOT_CHECK_UNAVAILABLE_MESSAGE =
  "The security check didn't finish. You can try again, or reload the page if it doesn't appear.";
